export default __webpack_public_path__ + "static/media/all-white.516a12cf.png";